import React from 'react';
import { ToastProvider } from './ToastContext';
import { CatalogProvider } from './CatalogContext';
import { PromotionsProvider } from './PromotionsContext';
import { AuthProvider } from './AuthContext';
import { CartProvider } from './CartContext';
import { WishlistProvider } from './WishlistContext';
import { OrdersProvider } from './OrdersContext';

/** Composes all customer-store contexts in the correct order. */
export function StoreProvider({ children }: { children: React.ReactNode }) {
  return (
    <ToastProvider>
      <CatalogProvider>
        <PromotionsProvider>
          <AuthProvider>
            <CartProvider>
              <WishlistProvider>
                <OrdersProvider>{children}</OrdersProvider>
              </WishlistProvider>
            </CartProvider>
          </AuthProvider>
        </PromotionsProvider>
      </CatalogProvider>
    </ToastProvider>
  );
}
